import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
 
const translations = {
  en: require('../../../Translate/en.json').VisualProduction.DocumentaryProduction,
  ar: require('../../../Translate/ar.json').VisualProduction.DocumentaryProduction,
};

const DocumentaryCard = () => {
  const { i18n } = useTranslation();
    const isLang = i18n.language;
  const t = translations[isLang || 'en'];

  return (
    <div className="documentary-card">
      <h2 className="documentary-title">{t.title}</h2>
      <div className="documentary-features">
        {Object.keys(t.features).map((key, index) => (
          <div className="feature" key={index}>
            <p>
              <b>{t.features[key].title}:</b> {t.features[key].description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentaryCard;
